import { createFileRoute } from "@tanstack/react-router";
import EsServicePage from "@/pages/es/EsServicePage";
import { esPsychotherapy } from "@/pages/es/esServiceData";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/services/psychotherapy`;

export const Route = createFileRoute("/es/services/psychotherapy")({
  head: () => ({
    meta: [
      { title: "Psicoterapia en Coral Springs | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "Servicios de psicoterapia individual, de pareja y grupal basados en evidencia en Coral Springs, FL. TCC, TDC y EMDR integrados con tratamientos avanzados.",
      },
      { property: "og:title", content: "Psicoterapia | Neuro Wellness TMS" },
      {
        property: "og:description",
        content:
          "Psicoterapia basada en evidencia en Coral Springs, FL. TCC, TDC y EMDR.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Psicoterapia | Neuro Wellness TMS" },
      {
        name: "twitter:description",
        content:
          "Psicoterapia basada en evidencia en Coral Springs, FL. TCC, TDC y EMDR.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/services/psychotherapy"),
    ],
  }),
  component: () => <EsServicePage cfg={esPsychotherapy} />,
});
